"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PageLevelHeadingState = /** @class */ (function () {
    function PageLevelHeadingState() {
    }
    return PageLevelHeadingState;
}());
exports.default = PageLevelHeadingState;
//# sourceMappingURL=PageLevelHeadingState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/PageLevelHeading/PageLevelHeadingState.js
// module id = 1520
// module chunks = 8